import { configureStore } from "@reduxjs/toolkit";
import dashboardReducer from "../slices/dashboardSlice";
import permissionsReducer from "../slices/permissionsSlice";
import userListReducer from "../slices/userListSlice";
import userRequestReducer from "../slices/userRequestSlice";
import useGroupReducer from "../slices/userGroupSlice";
import useQuestionReducer from "../slices/questionSlice";
import useResourceReducer from "../slices/resourceSlice";
import useFileReducer from "../slices/fileSlice";
import useAccessControlReducer from "../slices/accessControlSlice";
import useMessageTemplateReducer from "../slices/messageTemplateSlice";
import useLessonReducer from "../slices/lessonSlice";
import activityReducer from "../slices/activitySlice";
import cmsMessageReducer from "../slices/cmsMessageSlice";
import userNavigationReducer from "../slices/userNavigationSlice";

export const store = configureStore({
  reducer: {
    dashboard: dashboardReducer,
    permissions: permissionsReducer,
    userList: userListReducer,
    userRequests: userRequestReducer,
    groups: useGroupReducer,
    questions: useQuestionReducer,
    resource: useResourceReducer,
    file: useFileReducer,
    admin: useAccessControlReducer,
    messageTemplate: useMessageTemplateReducer,
    lesson: useLessonReducer,
    activity: activityReducer,
    cmsMessages: cmsMessageReducer,
    userNavigation: userNavigationReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
